<template lang="pug">
</template>

<script>
import L from 'leaflet';
import 'leaflet-easyprint';

export default {
  name: 'PrintMapControl',

  components: {
  },

  props: {
    // el map en el cual esta renderizado el componente
    map: {
      type: Object,
      required: true
    },
    // posicion del control con los valores permitiod de leaflet
    position: {
      type: String,
      default: 'topleft',
      validator(value) {
        return ['topright', 'topleft', 'bottomright', 'bottomleft'].includes(value);
      }
    }
  },

  data() {
    return {
    };
  },

  computed: {
  },

  mounted() {
    L.easyPrint({
      title: 'Imprimir mapa',
      position: this.position,
      sizeModes: ['Current', 'A4Portrait', 'A4Landscape'],
      filename: 'mapa',
      exportOnly: false,
      hideControlContainer: true
    }).addTo(this.map);

    setTimeout(() => {
      const dropdown = document.querySelectorAll('.leaflet-control-easyPrint .easyPrintHolder li');
      if (dropdown.length >= 3) {
        dropdown[0].title = 'Tamaño actual';
        dropdown[1].title = 'A4 Vertical';
        dropdown[2].title = 'A4 Horizontal';
      }
    }, 500);
  },

  methods: {
  }
};
</script>
